import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _45b427ff = () => interopDefault(import('../pages/contact-form.vue' /* webpackChunkName: "pages/contact-form" */))
const _29c75401 = () => interopDefault(import('../pages/contacts.vue' /* webpackChunkName: "pages/contacts" */))
const _170e997a = () => interopDefault(import('../pages/documents.vue' /* webpackChunkName: "pages/documents" */))
const _4c7b10d8 = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _bb7936ec = () => interopDefault(import('../pages/events/index.vue' /* webpackChunkName: "pages/events/index" */))
const _51715f6a = () => interopDefault(import('../pages/experts.vue' /* webpackChunkName: "pages/experts" */))
const _f3654b50 = () => interopDefault(import('../pages/faq.vue' /* webpackChunkName: "pages/faq" */))
const _75b2f633 = () => interopDefault(import('../pages/feedback.vue' /* webpackChunkName: "pages/feedback" */))
const _2cc2fe28 = () => interopDefault(import('../pages/ifc.vue' /* webpackChunkName: "pages/ifc" */))
const _7c0d8537 = () => interopDefault(import('../pages/invite.vue' /* webpackChunkName: "pages/invite" */))
const _fd4ac978 = () => interopDefault(import('../pages/news/index.vue' /* webpackChunkName: "pages/news/index" */))
const _4f80dc77 = () => interopDefault(import('../pages/photo/index.vue' /* webpackChunkName: "pages/photo/index" */))
const _171579ee = () => interopDefault(import('../pages/user/index.ts' /* webpackChunkName: "pages/user/index" */))
const _a0abb7f4 = () => interopDefault(import('../pages/wyf2024.vue' /* webpackChunkName: "pages/wyf2024" */))
const _5f110542 = () => interopDefault(import('../pages/auth/change-password.vue' /* webpackChunkName: "pages/auth/change-password" */))
const _4a82ff12 = () => interopDefault(import('../pages/auth/impersonalize.vue' /* webpackChunkName: "pages/auth/impersonalize" */))
const _3e06caf0 = () => interopDefault(import('../pages/auth/login.vue' /* webpackChunkName: "pages/auth/login" */))
const _2d7332fc = () => interopDefault(import('../pages/auth/registration.vue' /* webpackChunkName: "pages/auth/registration" */))
const _0c9bceb1 = () => interopDefault(import('../pages/events/mfm2026/index.vue' /* webpackChunkName: "pages/events/mfm2026/index" */))
const _a763765a = () => interopDefault(import('../pages/user/commission-requests/index.vue' /* webpackChunkName: "pages/user/commission-requests/index" */))
const _692a13a3 = () => interopDefault(import('../pages/user/events/index.ts' /* webpackChunkName: "pages/user/events/index" */))
const _11728a4d = () => interopDefault(import('../pages/user/requests/index.vue' /* webpackChunkName: "pages/user/requests/index" */))
const _6b5425e6 = () => interopDefault(import('../pages/events/mfm2026/program/index.vue' /* webpackChunkName: "pages/events/mfm2026/program/index" */))
const _47419f7c = () => interopDefault(import('../pages/events/mfm2026/select-status.vue' /* webpackChunkName: "pages/events/mfm2026/select-status" */))
const _fb2a0f9e = () => interopDefault(import('../pages/user/events/all.vue' /* webpackChunkName: "pages/user/events/all" */))
const _1be2544f = () => interopDefault(import('../pages/user/events/my/index.vue' /* webpackChunkName: "pages/user/events/my/index" */))
const _195e69ce = () => interopDefault(import('../pages/events/mfm2026/program/_id.vue' /* webpackChunkName: "pages/events/mfm2026/program/_id" */))
const _5a5c4170 = () => interopDefault(import('../pages/user/events/my/_eventAlias/index.ts' /* webpackChunkName: "pages/user/events/my/_eventAlias/index" */))
const _777e1135 = () => interopDefault(import('../pages/user/events/my/_eventAlias/accommodation.vue' /* webpackChunkName: "pages/user/events/my/_eventAlias/accommodation" */))
const _33caaedd = () => interopDefault(import('../pages/user/events/my/_eventAlias/art-masters-open.vue' /* webpackChunkName: "pages/user/events/my/_eventAlias/art-masters-open" */))
const _3638a937 = () => interopDefault(import('../pages/user/events/my/_eventAlias/contest.vue' /* webpackChunkName: "pages/user/events/my/_eventAlias/contest" */))
const _35429e1b = () => interopDefault(import('../pages/user/events/my/_eventAlias/documents.vue' /* webpackChunkName: "pages/user/events/my/_eventAlias/documents" */))
const _1ae94d1c = () => interopDefault(import('../pages/user/events/my/_eventAlias/feedback.vue' /* webpackChunkName: "pages/user/events/my/_eventAlias/feedback" */))
const _6a35984b = () => interopDefault(import('../pages/user/events/my/_eventAlias/food.vue' /* webpackChunkName: "pages/user/events/my/_eventAlias/food" */))
const _0a970ea4 = () => interopDefault(import('../pages/user/events/my/_eventAlias/participation.vue' /* webpackChunkName: "pages/user/events/my/_eventAlias/participation" */))
const _420875fc = () => interopDefault(import('../pages/user/events/my/_eventAlias/pcr.vue' /* webpackChunkName: "pages/user/events/my/_eventAlias/pcr" */))
const _fdc34ab2 = () => interopDefault(import('../pages/user/events/my/_eventAlias/program.vue' /* webpackChunkName: "pages/user/events/my/_eventAlias/program" */))
const _c30d1d7a = () => interopDefault(import('../pages/user/events/my/_eventAlias/regional-program.vue' /* webpackChunkName: "pages/user/events/my/_eventAlias/regional-program" */))
const _1fba926c = () => interopDefault(import('../pages/user/events/my/_eventAlias/team.vue' /* webpackChunkName: "pages/user/events/my/_eventAlias/team" */))
const _a4b676dc = () => interopDefault(import('../pages/user/events/my/_eventAlias/trip.vue' /* webpackChunkName: "pages/user/events/my/_eventAlias/trip" */))
const _0abf3f39 = () => interopDefault(import('../pages/user/commission-requests/_eventAlias/index.vue' /* webpackChunkName: "pages/user/commission-requests/_eventAlias/index" */))
const _13d7d734 = () => interopDefault(import('../pages/user/profile/_groupAlias.vue' /* webpackChunkName: "pages/user/profile/_groupAlias" */))
const _081e9034 = () => interopDefault(import('../pages/user/commission-requests/_eventAlias/_requestId.vue' /* webpackChunkName: "pages/user/commission-requests/_eventAlias/_requestId" */))
const _4cd2ae2e = () => interopDefault(import('../pages/user/commission-requests/_eventAlias/_requestId/index.ts' /* webpackChunkName: "pages/user/commission-requests/_eventAlias/_requestId/index" */))
const _4d1dc88e = () => interopDefault(import('../pages/user/commission-requests/_eventAlias/_requestId/contest.vue' /* webpackChunkName: "pages/user/commission-requests/_eventAlias/_requestId/contest" */))
const _bfc99d60 = () => interopDefault(import('../pages/user/commission-requests/_eventAlias/_requestId/trip.vue' /* webpackChunkName: "pages/user/commission-requests/_eventAlias/_requestId/trip" */))
const _37cda0d6 = () => interopDefault(import('../pages/user/requests/_eventAlias/_action/_requestId/_groupAlias.vue' /* webpackChunkName: "pages/user/requests/_eventAlias/_action/_requestId/_groupAlias" */))
const _16a78470 = () => interopDefault(import('../pages/events/_eventAlias/index.vue' /* webpackChunkName: "pages/events/_eventAlias/index" */))
const _f2a18462 = () => interopDefault(import('../pages/news/_alias.vue' /* webpackChunkName: "pages/news/_alias" */))
const _f090fe46 = () => interopDefault(import('../pages/photo/_eventAlias/index.vue' /* webpackChunkName: "pages/photo/_eventAlias/index" */))
const _68e30880 = () => interopDefault(import('../pages/photo/_eventAlias/_groupId.vue' /* webpackChunkName: "pages/photo/_eventAlias/_groupId" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/contact-form",
    component: _45b427ff,
    name: "contact-form___ru___default"
  }, {
    path: "/contacts",
    component: _29c75401,
    name: "contacts___ru___default"
  }, {
    path: "/documents",
    component: _170e997a,
    name: "documents___ru___default"
  }, {
    path: "/en",
    component: _4c7b10d8,
    name: "index___en"
  }, {
    path: "/events",
    component: _bb7936ec,
    name: "events___ru___default"
  }, {
    path: "/experts",
    component: _51715f6a,
    name: "experts___ru___default"
  }, {
    path: "/faq",
    component: _f3654b50,
    name: "faq___ru___default"
  }, {
    path: "/feedback",
    component: _75b2f633,
    name: "feedback___ru___default"
  }, {
    path: "/ifc",
    component: _2cc2fe28,
    name: "ifc___ru___default"
  }, {
    path: "/invite",
    component: _7c0d8537,
    name: "invite___ru___default"
  }, {
    path: "/news",
    component: _fd4ac978,
    name: "news___ru___default"
  }, {
    path: "/photo",
    component: _4f80dc77,
    name: "photo___ru___default"
  }, {
    path: "/ru",
    component: _4c7b10d8,
    name: "index___ru"
  }, {
    path: "/user",
    component: _171579ee,
    name: "user___ru___default"
  }, {
    path: "/wyf2024",
    component: _a0abb7f4,
    name: "wyf2024___ru___default"
  }, {
    path: "/auth/change-password",
    component: _5f110542,
    name: "auth-change-password___ru___default"
  }, {
    path: "/auth/impersonalize",
    component: _4a82ff12,
    name: "auth-impersonalize___ru___default"
  }, {
    path: "/auth/login",
    component: _3e06caf0,
    name: "auth-login___ru___default"
  }, {
    path: "/auth/registration",
    component: _2d7332fc,
    name: "auth-registration___ru___default"
  }, {
    path: "/en/contact-form",
    component: _45b427ff,
    name: "contact-form___en"
  }, {
    path: "/en/contacts",
    component: _29c75401,
    name: "contacts___en"
  }, {
    path: "/en/documents",
    component: _170e997a,
    name: "documents___en"
  }, {
    path: "/en/events",
    component: _bb7936ec,
    name: "events___en"
  }, {
    path: "/en/experts",
    component: _51715f6a,
    name: "experts___en"
  }, {
    path: "/en/faq",
    component: _f3654b50,
    name: "faq___en"
  }, {
    path: "/en/feedback",
    component: _75b2f633,
    name: "feedback___en"
  }, {
    path: "/en/ifc",
    component: _2cc2fe28,
    name: "ifc___en"
  }, {
    path: "/en/invite",
    component: _7c0d8537,
    name: "invite___en"
  }, {
    path: "/en/news",
    component: _fd4ac978,
    name: "news___en"
  }, {
    path: "/en/photo",
    component: _4f80dc77,
    name: "photo___en"
  }, {
    path: "/en/user",
    component: _171579ee,
    name: "user___en"
  }, {
    path: "/en/wyf2024",
    component: _a0abb7f4,
    name: "wyf2024___en"
  }, {
    path: "/events/mfm2026",
    component: _0c9bceb1,
    name: "events-mfm2026___ru___default"
  }, {
    path: "/ru/contact-form",
    component: _45b427ff,
    name: "contact-form___ru"
  }, {
    path: "/ru/contacts",
    component: _29c75401,
    name: "contacts___ru"
  }, {
    path: "/ru/documents",
    component: _170e997a,
    name: "documents___ru"
  }, {
    path: "/ru/events",
    component: _bb7936ec,
    name: "events___ru"
  }, {
    path: "/ru/experts",
    component: _51715f6a,
    name: "experts___ru"
  }, {
    path: "/ru/faq",
    component: _f3654b50,
    name: "faq___ru"
  }, {
    path: "/ru/feedback",
    component: _75b2f633,
    name: "feedback___ru"
  }, {
    path: "/ru/ifc",
    component: _2cc2fe28,
    name: "ifc___ru"
  }, {
    path: "/ru/invite",
    component: _7c0d8537,
    name: "invite___ru"
  }, {
    path: "/ru/news",
    component: _fd4ac978,
    name: "news___ru"
  }, {
    path: "/ru/photo",
    component: _4f80dc77,
    name: "photo___ru"
  }, {
    path: "/ru/user",
    component: _171579ee,
    name: "user___ru"
  }, {
    path: "/ru/wyf2024",
    component: _a0abb7f4,
    name: "wyf2024___ru"
  }, {
    path: "/user/commission-requests",
    component: _a763765a,
    name: "user-commission-requests___ru___default"
  }, {
    path: "/user/events",
    component: _692a13a3,
    name: "user-events___ru___default"
  }, {
    path: "/user/requests",
    component: _11728a4d,
    name: "user-requests___ru___default"
  }, {
    path: "/en/auth/change-password",
    component: _5f110542,
    name: "auth-change-password___en"
  }, {
    path: "/en/auth/impersonalize",
    component: _4a82ff12,
    name: "auth-impersonalize___en"
  }, {
    path: "/en/auth/login",
    component: _3e06caf0,
    name: "auth-login___en"
  }, {
    path: "/en/auth/registration",
    component: _2d7332fc,
    name: "auth-registration___en"
  }, {
    path: "/en/events/mfm2026",
    component: _0c9bceb1,
    name: "events-mfm2026___en"
  }, {
    path: "/en/user/commission-requests",
    component: _a763765a,
    name: "user-commission-requests___en"
  }, {
    path: "/en/user/events",
    component: _692a13a3,
    name: "user-events___en"
  }, {
    path: "/en/user/requests",
    component: _11728a4d,
    name: "user-requests___en"
  }, {
    path: "/events/mfm2026/program",
    component: _6b5425e6,
    name: "events-mfm2026-program___ru___default"
  }, {
    path: "/events/mfm2026/select-status",
    component: _47419f7c,
    name: "events-mfm2026-select-status___ru___default"
  }, {
    path: "/ru/auth/change-password",
    component: _5f110542,
    name: "auth-change-password___ru"
  }, {
    path: "/ru/auth/impersonalize",
    component: _4a82ff12,
    name: "auth-impersonalize___ru"
  }, {
    path: "/ru/auth/login",
    component: _3e06caf0,
    name: "auth-login___ru"
  }, {
    path: "/ru/auth/registration",
    component: _2d7332fc,
    name: "auth-registration___ru"
  }, {
    path: "/ru/events/mfm2026",
    component: _0c9bceb1,
    name: "events-mfm2026___ru"
  }, {
    path: "/ru/user/commission-requests",
    component: _a763765a,
    name: "user-commission-requests___ru"
  }, {
    path: "/ru/user/events",
    component: _692a13a3,
    name: "user-events___ru"
  }, {
    path: "/ru/user/requests",
    component: _11728a4d,
    name: "user-requests___ru"
  }, {
    path: "/user/events/all",
    component: _fb2a0f9e,
    name: "user-events-all___ru___default"
  }, {
    path: "/user/events/my",
    component: _1be2544f,
    name: "user-events-my___ru___default"
  }, {
    path: "/en/events/mfm2026/program",
    component: _6b5425e6,
    name: "events-mfm2026-program___en"
  }, {
    path: "/en/events/mfm2026/select-status",
    component: _47419f7c,
    name: "events-mfm2026-select-status___en"
  }, {
    path: "/en/user/events/all",
    component: _fb2a0f9e,
    name: "user-events-all___en"
  }, {
    path: "/en/user/events/my",
    component: _1be2544f,
    name: "user-events-my___en"
  }, {
    path: "/ru/events/mfm2026/program",
    component: _6b5425e6,
    name: "events-mfm2026-program___ru"
  }, {
    path: "/ru/events/mfm2026/select-status",
    component: _47419f7c,
    name: "events-mfm2026-select-status___ru"
  }, {
    path: "/ru/user/events/all",
    component: _fb2a0f9e,
    name: "user-events-all___ru"
  }, {
    path: "/ru/user/events/my",
    component: _1be2544f,
    name: "user-events-my___ru"
  }, {
    path: "/",
    component: _4c7b10d8,
    name: "index___ru___default"
  }, {
    path: "/en/events/mfm2026/program/:id",
    component: _195e69ce,
    name: "events-mfm2026-program-id___en"
  }, {
    path: "/en/user/events/my/:eventAlias",
    component: _5a5c4170,
    name: "user-events-my-eventAlias___en"
  }, {
    path: "/ru/events/mfm2026/program/:id",
    component: _195e69ce,
    name: "events-mfm2026-program-id___ru"
  }, {
    path: "/ru/user/events/my/:eventAlias",
    component: _5a5c4170,
    name: "user-events-my-eventAlias___ru"
  }, {
    path: "/en/user/events/my/:eventAlias/accommodation",
    component: _777e1135,
    name: "user-events-my-eventAlias-accommodation___en"
  }, {
    path: "/en/user/events/my/:eventAlias/art-masters-open",
    component: _33caaedd,
    name: "user-events-my-eventAlias-art-masters-open___en"
  }, {
    path: "/en/user/events/my/:eventAlias/contest",
    component: _3638a937,
    name: "user-events-my-eventAlias-contest___en"
  }, {
    path: "/en/user/events/my/:eventAlias/documents",
    component: _35429e1b,
    name: "user-events-my-eventAlias-documents___en"
  }, {
    path: "/en/user/events/my/:eventAlias/feedback",
    component: _1ae94d1c,
    name: "user-events-my-eventAlias-feedback___en"
  }, {
    path: "/en/user/events/my/:eventAlias/food",
    component: _6a35984b,
    name: "user-events-my-eventAlias-food___en"
  }, {
    path: "/en/user/events/my/:eventAlias/participation",
    component: _0a970ea4,
    name: "user-events-my-eventAlias-participation___en"
  }, {
    path: "/en/user/events/my/:eventAlias/pcr",
    component: _420875fc,
    name: "user-events-my-eventAlias-pcr___en"
  }, {
    path: "/en/user/events/my/:eventAlias/program",
    component: _fdc34ab2,
    name: "user-events-my-eventAlias-program___en"
  }, {
    path: "/en/user/events/my/:eventAlias/regional-program",
    component: _c30d1d7a,
    name: "user-events-my-eventAlias-regional-program___en"
  }, {
    path: "/en/user/events/my/:eventAlias/team",
    component: _1fba926c,
    name: "user-events-my-eventAlias-team___en"
  }, {
    path: "/en/user/events/my/:eventAlias/trip",
    component: _a4b676dc,
    name: "user-events-my-eventAlias-trip___en"
  }, {
    path: "/ru/user/events/my/:eventAlias/accommodation",
    component: _777e1135,
    name: "user-events-my-eventAlias-accommodation___ru"
  }, {
    path: "/ru/user/events/my/:eventAlias/art-masters-open",
    component: _33caaedd,
    name: "user-events-my-eventAlias-art-masters-open___ru"
  }, {
    path: "/ru/user/events/my/:eventAlias/contest",
    component: _3638a937,
    name: "user-events-my-eventAlias-contest___ru"
  }, {
    path: "/ru/user/events/my/:eventAlias/documents",
    component: _35429e1b,
    name: "user-events-my-eventAlias-documents___ru"
  }, {
    path: "/ru/user/events/my/:eventAlias/feedback",
    component: _1ae94d1c,
    name: "user-events-my-eventAlias-feedback___ru"
  }, {
    path: "/ru/user/events/my/:eventAlias/food",
    component: _6a35984b,
    name: "user-events-my-eventAlias-food___ru"
  }, {
    path: "/ru/user/events/my/:eventAlias/participation",
    component: _0a970ea4,
    name: "user-events-my-eventAlias-participation___ru"
  }, {
    path: "/ru/user/events/my/:eventAlias/pcr",
    component: _420875fc,
    name: "user-events-my-eventAlias-pcr___ru"
  }, {
    path: "/ru/user/events/my/:eventAlias/program",
    component: _fdc34ab2,
    name: "user-events-my-eventAlias-program___ru"
  }, {
    path: "/ru/user/events/my/:eventAlias/regional-program",
    component: _c30d1d7a,
    name: "user-events-my-eventAlias-regional-program___ru"
  }, {
    path: "/ru/user/events/my/:eventAlias/team",
    component: _1fba926c,
    name: "user-events-my-eventAlias-team___ru"
  }, {
    path: "/ru/user/events/my/:eventAlias/trip",
    component: _a4b676dc,
    name: "user-events-my-eventAlias-trip___ru"
  }, {
    path: "/en/user/commission-requests/:eventAlias",
    component: _0abf3f39,
    name: "user-commission-requests-eventAlias___en"
  }, {
    path: "/en/user/profile/:groupAlias?",
    component: _13d7d734,
    name: "user-profile-groupAlias___en"
  }, {
    path: "/events/mfm2026/program/:id",
    component: _195e69ce,
    name: "events-mfm2026-program-id___ru___default"
  }, {
    path: "/ru/user/commission-requests/:eventAlias",
    component: _0abf3f39,
    name: "user-commission-requests-eventAlias___ru"
  }, {
    path: "/ru/user/profile/:groupAlias?",
    component: _13d7d734,
    name: "user-profile-groupAlias___ru"
  }, {
    path: "/user/events/my/:eventAlias",
    component: _5a5c4170,
    name: "user-events-my-eventAlias___ru___default"
  }, {
    path: "/user/events/my/:eventAlias/accommodation",
    component: _777e1135,
    name: "user-events-my-eventAlias-accommodation___ru___default"
  }, {
    path: "/user/events/my/:eventAlias/art-masters-open",
    component: _33caaedd,
    name: "user-events-my-eventAlias-art-masters-open___ru___default"
  }, {
    path: "/user/events/my/:eventAlias/contest",
    component: _3638a937,
    name: "user-events-my-eventAlias-contest___ru___default"
  }, {
    path: "/user/events/my/:eventAlias/documents",
    component: _35429e1b,
    name: "user-events-my-eventAlias-documents___ru___default"
  }, {
    path: "/user/events/my/:eventAlias/feedback",
    component: _1ae94d1c,
    name: "user-events-my-eventAlias-feedback___ru___default"
  }, {
    path: "/user/events/my/:eventAlias/food",
    component: _6a35984b,
    name: "user-events-my-eventAlias-food___ru___default"
  }, {
    path: "/user/events/my/:eventAlias/participation",
    component: _0a970ea4,
    name: "user-events-my-eventAlias-participation___ru___default"
  }, {
    path: "/user/events/my/:eventAlias/pcr",
    component: _420875fc,
    name: "user-events-my-eventAlias-pcr___ru___default"
  }, {
    path: "/user/events/my/:eventAlias/program",
    component: _fdc34ab2,
    name: "user-events-my-eventAlias-program___ru___default"
  }, {
    path: "/user/events/my/:eventAlias/regional-program",
    component: _c30d1d7a,
    name: "user-events-my-eventAlias-regional-program___ru___default"
  }, {
    path: "/user/events/my/:eventAlias/team",
    component: _1fba926c,
    name: "user-events-my-eventAlias-team___ru___default"
  }, {
    path: "/user/events/my/:eventAlias/trip",
    component: _a4b676dc,
    name: "user-events-my-eventAlias-trip___ru___default"
  }, {
    path: "/en/user/commission-requests/:eventAlias?/:requestId",
    component: _081e9034,
    children: [{
      path: "",
      component: _4cd2ae2e,
      name: "user-commission-requests-eventAlias-requestId___en"
    }, {
      path: "contest",
      component: _4d1dc88e,
      name: "user-commission-requests-eventAlias-requestId-contest___en"
    }, {
      path: "trip",
      component: _bfc99d60,
      name: "user-commission-requests-eventAlias-requestId-trip___en"
    }]
  }, {
    path: "/ru/user/commission-requests/:eventAlias?/:requestId",
    component: _081e9034,
    children: [{
      path: "",
      component: _4cd2ae2e,
      name: "user-commission-requests-eventAlias-requestId___ru"
    }, {
      path: "contest",
      component: _4d1dc88e,
      name: "user-commission-requests-eventAlias-requestId-contest___ru"
    }, {
      path: "trip",
      component: _bfc99d60,
      name: "user-commission-requests-eventAlias-requestId-trip___ru"
    }]
  }, {
    path: "/en/user/requests/:eventAlias/:action?/:requestId?/:groupAlias?",
    component: _37cda0d6,
    name: "user-requests-eventAlias-action-requestId-groupAlias___en"
  }, {
    path: "/ru/user/requests/:eventAlias/:action?/:requestId?/:groupAlias?",
    component: _37cda0d6,
    name: "user-requests-eventAlias-action-requestId-groupAlias___ru"
  }, {
    path: "/en/events/:eventAlias",
    component: _16a78470,
    name: "events-eventAlias___en"
  }, {
    path: "/en/news/:alias",
    component: _f2a18462,
    name: "news-alias___en"
  }, {
    path: "/en/photo/:eventAlias",
    component: _f090fe46,
    name: "photo-eventAlias___en"
  }, {
    path: "/ru/events/:eventAlias",
    component: _16a78470,
    name: "events-eventAlias___ru"
  }, {
    path: "/ru/news/:alias",
    component: _f2a18462,
    name: "news-alias___ru"
  }, {
    path: "/ru/photo/:eventAlias",
    component: _f090fe46,
    name: "photo-eventAlias___ru"
  }, {
    path: "/user/commission-requests/:eventAlias",
    component: _0abf3f39,
    name: "user-commission-requests-eventAlias___ru___default"
  }, {
    path: "/user/profile/:groupAlias?",
    component: _13d7d734,
    name: "user-profile-groupAlias___ru___default"
  }, {
    path: "/en/photo/:eventAlias/:groupId",
    component: _68e30880,
    name: "photo-eventAlias-groupId___en"
  }, {
    path: "/ru/photo/:eventAlias/:groupId",
    component: _68e30880,
    name: "photo-eventAlias-groupId___ru"
  }, {
    path: "/user/commission-requests/:eventAlias?/:requestId",
    component: _081e9034,
    children: [{
      path: "",
      component: _4cd2ae2e,
      name: "user-commission-requests-eventAlias-requestId___ru___default"
    }, {
      path: "contest",
      component: _4d1dc88e,
      name: "user-commission-requests-eventAlias-requestId-contest___ru___default"
    }, {
      path: "trip",
      component: _bfc99d60,
      name: "user-commission-requests-eventAlias-requestId-trip___ru___default"
    }]
  }, {
    path: "/user/requests/:eventAlias/:action?/:requestId?/:groupAlias?",
    component: _37cda0d6,
    name: "user-requests-eventAlias-action-requestId-groupAlias___ru___default"
  }, {
    path: "/events/:eventAlias",
    component: _16a78470,
    name: "events-eventAlias___ru___default"
  }, {
    path: "/news/:alias",
    component: _f2a18462,
    name: "news-alias___ru___default"
  }, {
    path: "/photo/:eventAlias",
    component: _f090fe46,
    name: "photo-eventAlias___ru___default"
  }, {
    path: "/photo/:eventAlias/:groupId",
    component: _68e30880,
    name: "photo-eventAlias-groupId___ru___default"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
